"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GroceriesOnline = function GroceriesOnline(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.4677 10.5994C20.0964 10.2268 19.4934 10.2258 19.1209 10.5971H17.8743V9.20899C17.8743 7.71286 16.6615 6.5 15.1653 6.5H8.20899C6.71286 6.5 5.5 7.71286 5.5 9.20899V17.1243C5.5 18.6205 6.71286 19.8333 8.20899 19.8333H21.8429C23.339 19.8333 24.5519 18.6205 24.5519 17.1243V14.6975L20.4677 10.5994Z",
    fill: "#E8F1FB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.6471 15.4845L19.1186 11.944C18.7473 11.5714 18.7483 10.9684 19.1209 10.5971C19.4934 10.2258 20.0964 10.2268 20.4677 10.5994L24.5519 14.6975V17.1243C24.5519 18.6205 23.339 19.8333 21.8429 19.8333H8.20899C6.71286 19.8333 5.5 18.6205 5.5 17.1243V9.20899C5.5 7.71286 6.71286 6.5 8.20899 6.5H15.1653C16.6615 6.5 17.8743 7.71286 17.8743 9.20899V15.091C17.8743 15.617 17.4479 16.0434 16.9219 16.0434C16.396 16.0434 15.9696 15.617 15.9696 15.091V9.20899C15.9696 8.76483 15.6095 8.40476 15.1653 8.40476H8.20899C7.76483 8.40476 7.40476 8.76483 7.40476 9.20899V17.1243C7.40476 17.5685 7.76483 17.9286 8.20899 17.9286H21.8429C22.287 17.9286 22.6471 17.5685 22.6471 17.1243V15.4845Z",
    fill: "#1976D2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.0238 22.9048C18.0238 23.9567 18.8766 24.8095 19.9286 24.8095C20.9805 24.8095 21.8333 23.9567 21.8333 22.9048C21.8333 21.8528 20.9805 21 19.9286 21C18.8766 21 18.0238 21.8528 18.0238 22.9048Z",
    fill: "#1976D2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.5 22.9048C8.5 23.9567 9.35279 24.8095 10.4048 24.8095C11.4567 24.8095 12.3095 23.9567 12.3095 22.9048C12.3095 21.8528 11.4567 21 10.4048 21C9.35279 21 8.5 21.8528 8.5 22.9048Z",
    fill: "#1976D2"
  }));
};

GroceriesOnline.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
GroceriesOnline.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = GroceriesOnline;
exports.default = _default;